import React from "react";
import { getItemThumbnail } from "../../../assets/js/utils/utils";
import { StoreCategory } from "@/assets/interfaces";
import Router from "next/router";
import StorefrontContext from "@/contexts/storefront";
import classNames from "classnames";

interface Props {
  storeId: string;
  store: string;
}

const SmallHeaderCards: React.FC<Props> = ({ storeId, store }) => {
  const { categoriesWithItems, isLoadingCategories, paths } = StorefrontContext.useContainer();
  // const categories = categoriesWithItems.sort((a, b) => b.items_count - a.items_count).slice(0, 3);

  if (isLoadingCategories) {
    return (
      <div className="w-full mx-auto mt-7.5">
        <div className="store-container">
          <h3 className="text-black text-lg sm:text-xl md:text-xl font-bold flex items-center mb-3.5">Categories</h3>
          <div className="flex flex-wrap gap-4 w-full">
            {Array.from({ length: 5 }).map((_, index) => (
              <div
                key={index}
                className="w-full bg-grey-loader rounded-10 animate-pulse h-12.5 max-w-[225px] px-1.5 flex items-center gap-2.5"
              >
                <div className="h-9 w-9 bg-white animate-pulse rounded-[8px]"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames("w-full mx-auto mt-7.5")}>
      <div className="store-container">
        <h3 className="text-black text-lg sm:text-xl md:text-xl font-bold flex items-center mb-3.5">Categories</h3>
        <div className="flex flex-wrap gap-4 w-full">
          {categoriesWithItems.map((category) => (
            <CategoryItem key={category.id} category={category} paths={paths} />
          ))}
        </div>
      </div>
    </div>
  );
};

const CategoryItem: React.FC<{ category: StoreCategory; paths: any }> = ({ category, paths }) => {
  return (
    <article
      onClick={() => Router.push(`${paths.products}?category=${category.id}`)}
      className="flex-shrink-0 relative overflow-hidden rounded-10 group flex items-center border border-grey-divider flex-1 sm:flex-none h-12.5 px-1.5 min-w-[140px] md:min-w-[160px] max-w-[250px] space-x-2.5 group ease-out transition-all duration-300 hover:bg-grey-fields-100 cursor-pointer"
    >
      <figure className="h-9 w-9 rounded-[8px] overflow-hidden group-hover:rounded-full group-hover:scale-110 backface-visibility-hidden ease-in transition-all duration-500">
        <img
          src={category.first_item ? getItemThumbnail(category.first_item) : ""}
          alt={category.name}
          className="h-full w-full object-cover"
        />
      </figure>
      <span className="text-dark text-sm font-medium hover:text-primary-500 ease-out transition-all duration-300 inline-block overflow-hidden truncate whitespace-nowrap max-w-[75%]">
        {category.name}
      </span>
    </article>
  );
};

export default SmallHeaderCards;
